import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import {   ServiceProvider, ServiceProvidersClient } from "src/app/web-api-client";

@Component({
  selector: 'app-serviceProvider-creation',
  templateUrl: './serviceProvider-creation.component.html',
  styleUrls: ['./serviceProvider-creation.component.scss']
})
export class ServiceProviderCreationComponent implements OnInit  {

  public isLoaded = true;
  public onClose = new Subject<boolean>();

   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public client:ServiceProvidersClient) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      serviceProviderName: ['', Validators.required],
      serviceProviderEIK: ['', Validators.required],
      isActive: [false, Validators.required]
    });
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new ServiceProvider();

      service.idServiceProvider= 0;
      service.serviceProviderName = this.Form.value.serviceProviderName;
      service.serviceProviderEIK = this.Form.value.serviceProviderEIK;
      service.isActive = this.Form.value.isActive;

      this.client.create(service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

}
